<div class="card" *ngIf="model">
  <div class="brand"><img [src]="'/assets/images/mini-logo-' + (model.Brand | lowercase) + '.svg'" class="brand-img" [alt]="model.Brand"></div>
  <img [src]="model.ImageFile.FileUri" class="card-img-top" [alt]="model.Title">
  <div class="card-body">
    <h6 class="card-pretitle">{{model.CampaignType}}</h6>
    <h5 class="card-title">{{model.Title}}</h5>
    <span class="badge-new" data-bs-toggle="tooltip" data-bs-placement="top" title="Novedad" *ngIf="model.IsNew">
      N<span class="visually-hidden">Novedad</span>
    </span>
    <hr />
    <div class="row">
      <div class="col-md-6">
        <div class="date">
          <i class="fa fa-calendar"></i> Desde<br>
          <strong>{{model.CampaignInitDate | date:'dd-MM-yyyy'}}</strong>
        </div>
      </div>
      <div class="col-md-6">
        <div class="date">
          <i class="fa fa-calendar"></i> Hasta<br>
          <strong>{{model.CampaignEndDate | date:'dd-MM-yyyy'}}</strong>
        </div>
      </div>
    </div>
  </div>
  <div class="card-footer"><button *ngIf="user.CRMFullAccess" class="btn btn-primary w-100">{{ buttonAction }}</button></div>
</div>